import { FC, PropsWithChildren } from 'react';

import { HttpError } from '@bonusly/http';
import { useCurrentCompany } from '@bonusly/who-am-i';

type RequireFeatureProps = PropsWithChildren & {
	// Taxonomy feature id (snake_case), e.g. `external_recognition`. This is the
	// entitlement key on `company.feature_states`, resolved server-side from the
	// feature taxonomy — NOT an Amplitude experiment flag (that is `useFeatureFlag`,
	// which reads a different store keyed by experiment variant). Routes gated on a
	// product entitlement must use this, not FlaggedRoute.
	feature: string;
	// Default 404 (hide the route's existence) rather than 403 (which would admit
	// the route exists but is forbidden).
	statusCode?: number;
};

// Renders children only when the company is entitled to the given taxonomy
// feature. `feature_states[feature] === true` is required: features that are
// disabled-by-default (like external_recognition) must be explicitly turned on,
// so an absent/undefined entry is treated as off.
export const RequireFeature: FC<RequireFeatureProps> = ({ children, feature, statusCode = 404 }) => {
	const company = useCurrentCompany();

	if (company?.feature_states?.[feature] === true) {
		return <>{children}</>;
	}

	throw new HttpError(statusCode);
};
